import React from "react";
import api from "../@api";

class controllers extends React.Component {
  getProjectsList = (query) => {
    return new Promise((resolve, reject) => {
      api()
        .get("/projects/find", { params: query })
        .then((response) => {
          if (response.data.status === "success") {
            let data = response.data.result.Projects;
            resolve(data);
          }
          if (response.data.status === "failure") {
            reject("Something is wrong try later or contact the support");
          }
        })
        .catch((err) => {
          reject("Something is wrong try later or contact the support");
        });
    });
  };

  getProjectDetails = (projectId) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/projects/${projectId}`)
        .then((response) => {
          if (response.data.status === "success") {
            let data = response.data.project;
            resolve(data);
          }
          if (response.data.status === "failure") {
            reject("Something is wrong try later or contact the support");
          }
        })
        .catch((err) => {
          reject("Something is wrong try later or contact the support");
        });
    });
  };
}

const instance = new controllers();

export default instance;
